import { Button, Image } from "antd";
import React from "react";
import { HiOutlineLightBulb } from "react-icons/hi";
import { IoMdGlobe } from "react-icons/io";
import { VscOpenPreview } from "react-icons/vsc";
import { FaCrown } from "react-icons/fa";
import nosubscription from "../../../images/insights/OI_proversionimage.svg";

function NoSubCompareInput({ className = "input", style = {} }) {
    return (
        <div
            className={`nosubscription ${className}`}
            style={style}
        >
            <div className="nosubscription-imagecont">
                <Image src={nosubscription} preview={false} />
            </div>
            <div className="nosubscription-detailscont">
                <div className="nosubscription-flexjustify">
                    <span className="nosubscription-title">
                        Try ONE Intelligence
                    </span>
                    <span className="nosubscription-tag">
                        PRO
                    </span>
                </div>
                <div className="nosubscription-flexjustify">
                    <span className="nosubscription-boderbottom" />
                </div>
                <div className="text-center">Here’s what inside ONE Intelligence Pro</div>
                <div className="nosubscription-flexalign">
                    <VscOpenPreview />
                    <span>Compare Categories and Behavior</span>
                </div>
                <div className="nosubscription-flexalign">
                    <HiOutlineLightBulb />
                    <span>Single Category and Behavior Insight</span>
                </div>
                <div className="nosubscription-flexalign">
                    <IoMdGlobe />
                    <span>Language Translate Result</span>
                </div>
                <div className="nosubscription-flexjustify">
                    <Button type="primary" style={{ marginTop: "3mm" }} onClick={() => {
                        window.open("mailto: onemarket@sqreem.com")
                    }}>
                        <FaCrown style={{ marginRight: "2mm" }} />
                        <span>Upgrade Plan</span>
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default NoSubCompareInput;
